// Format an ISO date string (e.g. "2026-05-16") as UK long form: "Saturday 16 May 2026"
export function formatUKDate(iso) {
  if (!iso) return "";
  const d = new Date(iso + "T00:00:00");
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
